import React, { useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';

const AnimatedCounter = ({isDarkMode , totalCount }) => {

const getRoundedDisplay = (num) => {
    const roundTo = 10;
    const roundedDown = Math.floor(num / roundTo) * roundTo;
    return roundedDown
    };
  const [count, setCount] = useState(0);
  const [isInitialAnimationComplete, setIsInitialAnimationComplete] = useState(false);
  var targetCount =  getRoundedDisplay(totalCount);
  const duration = 2000;
  const stepTime = 20;
  
  useEffect(() => {
    console.log('totalCount',targetCount);
     if (count < targetCount) {
      const steps = duration / stepTime;
      const increment = targetCount / steps;
      
      const timer = setTimeout(() => {
        setCount(prevCount => {
          const newCount = prevCount + increment;
          if (newCount >= targetCount) {
            setIsInitialAnimationComplete(true);
            return targetCount;
          }
          return newCount;
        });
      }, stepTime);
      
      return () => clearTimeout(timer);
    }
  }, [totalCount , count]);

 

  const floatingClass = isInitialAnimationComplete 
    ? 'animate-pulse transform hover:scale-105 transition-all duration-1000' 
    : 'transform hover:scale-105 transition-transform duration-300';

  return (
    <div className={`flex  ${isDarkMode ? 'bg-transparent' : 'bg-transparent'}`}>
      <div className="relative">
        {/* Theme toggle button */}
        <div className="relative group">
          {/* Animated border background */}
          <div className={`absolute -inset-1 
                          ${isDarkMode 
                            ? 'bg-gradient-to-r from-pink-600 via-purple-600 to-indigo-600' 
                            : 'bg-gradient-to-r from-pink-400 via-purple-400 to-indigo-400'} 
                          rounded-lg blur-sm group-hover:blur opacity-75 
                          group-hover:opacity-100 animate-gradient-xy 
                          transition duration-500`}>
          </div>
          
          <div className={`relative inline-flex items-center rounded-lg px-6 py-3
                          ${isDarkMode ? 'bg-black/90' : 'bg-white/90'} 
                          ${floatingClass}`}>
            <div className="flex items-baseline gap-1">
              <span 
                className={`text-xl font-extrabold text-transparent bg-clip-text
                           ${isDarkMode 
                             ? 'bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400'
                             : 'bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600'}
                           ${isInitialAnimationComplete ? 'counter-bounce' : ''}`}
              >
                {Math.floor(count)} +
              </span>
              {/* <span className={`text-3xl font-bold ${isDarkMode ? 'text-pink-400' : 'text-pink-600'}`}>Loaders</span> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Add CSS for the gradient animation
const style = document.createElement('style');
style.textContent = `
  @keyframes gradient-xy {
    0%, 100% {
      background-size: 400% 400%;
      background-position: left top;
    }
    25% {
      background-position: right top;
    }
    50% {
      background-position: right bottom;
    }
    75% {
      background-position: left bottom;
    }
  }
     @keyframes bounce-count{
     0%,100%{
     transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
    }
    50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
    }
     
     }

    .counter-bounce{
        animation: bounce-count 1s infinite;
        }
  .animate-gradient-xy {
    animation: gradient-xy 15s ease infinite;
  }
`;
document.head.appendChild(style);

export default AnimatedCounter;